export default __webpack_public_path__ + "static/media/lock2.efc0f92e.png";